import { render } from "./AdminLandingView.vue?vue&type=template&id=541f2f56&scoped=true"
import script from "./AdminLandingView.vue?vue&type=script&lang=js"
export * from "./AdminLandingView.vue?vue&type=script&lang=js"

import "./AdminLandingView.vue?vue&type=style&index=0&id=541f2f56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541f2f56"]])

export default __exports__